// @format

import "bootstrap";
import "bootstrap-select";

let pageshowBound = false;

export function initSelectpicker(): void {
  $(document).ready(function () {
    $(".selectpicker, .selectpickerr").each(function () {
      const $el = $(this);
      if ($el.data("selectpicker")) {
        $el.selectpicker("refresh");
      } else {
        $el.selectpicker();
      }
    });
  });
  // destroySelectpicker();


  initStableDropdown();
  if (!pageshowBound) {
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        $(".selectpicker, .selectpickerr").each(function () {
          const $el = $(this);
          if ($el.data("selectpicker")) {
            $el.selectpicker("refresh");
          } else {
            $el.selectpicker();
          }
        });
        initStableDropdown();
      }
    });
    pageshowBound = true;
  }
}

export function destroySelectpicker(): void {
  $(".selectpicker, .selectpickerr").selectpicker("destroy");
}

function initStableDropdown(): void {
  $(".stable-dropdown").selectpicker({
    dropupAuto: false,
    size: 10,
    virtualScroll: 100,
    style: "btn-default",
  });

  $(".stable-dropdown").on("shown.bs.select", function () {
    var $select = $(this);
    var $dropdown = $select.closest(".bootstrap-select").find(".dropdown-menu");
    var $button = $select.closest(".bootstrap-select").find(".dropdown-toggle");

    var buttonHeight = $button.outerHeight();

    $dropdown.css({
      position: "absolute",
      top: buttonHeight + 2 + "px",
      left: "0px",
      "max-height": "400px",
      "overflow-y": "auto",
      "z-index": "9999",
      transform: "none",
      "will-change": "auto",
    });
  });
}
